import loadable from '@loadable/component';

// 懒加载组件
const OperationImplantationRequest = loadable(() => import('./operationImplantationRequest/OperationImplantationRequest'));
const OperationImplantationDetailModify = loadable(() => import('./operationImplantationRequest/operationImplantationDetailModify/OperationImplantationDetailModify'));
const StockupDeliveryQuery = loadable(() => import('./stockupDeliveryQuery/StockupDeliveryQuery'));
const StockupDeliveryModify = loadable(() => import('./stockupDeliveryQuery/stockupDeliveryModify/StockupDeliveryModify'));
const StockupDeliveryDetailQuery = loadable(() => import('./stockupDeliveryDetailQuery/StockupDeliveryDetailQuery'));
const OrderQuery = loadable(() => import('./orderQuery/OrderQuery'));
const DeliveryQuery = loadable(() => import('./deliveryQuery/DeliveryQuery'));
const DeliveryModify = loadable(() => import('./deliveryQuery/deliveryModify/DeliveryModify'));
const StockupOrderQuery = loadable(() => import('./stockupOrderQuery/StockupOrderQuery'));

export const subRoutes = [
  {
    path: '/OperationImplantationRequest',
    component: OperationImplantationRequest
  },
  {
    path: '/OperationImplantationDetailModify',
    component: OperationImplantationDetailModify
  },
  {
    path: '/StockupDeliveryQuery',
    component: StockupDeliveryQuery
  },
  {
    path: '/StockupDeliveryModify',
    component: StockupDeliveryModify
  },
  {
    // 242506备货发货单明细查询
    path: '/StockupDeliveryDetailQuery',
    component: StockupDeliveryDetailQuery
  },
  {
    // 242301耗材订单查询响应
    path: '/OrderQuery',
    component: OrderQuery
  },
  {
    // 242302耗材发货单查询
    path: '/DeliveryQuery',
    component: DeliveryQuery
  },
  {
    // 242302耗材发货单查询
    path: '/DeliveryModify',
    component: DeliveryModify
  },
  {
    // 242502备货订单查询响应
    path: '/StockupOrderQuery',
    component: StockupOrderQuery
  }
];
